import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Rss, Bell, Sparkles } from 'lucide-react';
import { useTelegram } from '@/core/providers';

const SLIDES = [
  {
    icon: Rss,
    title: 'Track What Matters',
    description: 'Follow topics, people, and trends that are important to you',
    gradient: 'from-blue-500 to-purple-600',
  },
  {
    icon: Bell,
    title: 'Stay Updated',
    description: 'Get real-time notifications when something interesting happens',
    gradient: 'from-purple-500 to-pink-600',
  },
  {
    icon: Sparkles,
    title: 'AI-Powered Insights',
    description: 'Let AI help you discover and summarize the most valuable content',
    gradient: 'from-pink-500 to-orange-600',
  },
];

function OnboardingPage() {
  const navigate = useNavigate();
  const { hapticFeedback } = useTelegram();
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleNext = () => {
    hapticFeedback('impact');
    if (currentSlide < SLIDES.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      // Mark onboarding as complete and navigate to feed
      localStorage.setItem('onboarding_completed', 'true');
      navigate('/feed');
    }
  };

  const handleSkip = () => {
    hapticFeedback('selection');
    localStorage.setItem('onboarding_completed', 'true');
    navigate('/feed');
  };

  const slide = SLIDES[currentSlide];
  const Icon = slide.icon;
  const isLastSlide = currentSlide === SLIDES.length - 1;

  return (
    <div className="h-full flex flex-col bg-telegram-bg">
      {/* Skip Button */}
      <div className="p-4 flex justify-end">
        {!isLastSlide && (
          <button
            onClick={handleSkip}
            className="text-telegram-hint hover:text-telegram-text text-sm"
          >
            Skip
          </button>
        )}
      </div>

      {/* Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-8">
        {/* Icon */}
        <div
          className={`w-32 h-32 rounded-full bg-gradient-to-br ${slide.gradient} flex items-center justify-center mb-8`}
        >
          <Icon size={64} className="text-white" />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-telegram-text text-center mb-4">
          {slide.title}
        </h1>

        {/* Description */}
        <p className="text-telegram-hint text-center mb-8 max-w-sm">
          {slide.description}
        </p>

        {/* Progress Dots */}
        <div className="flex gap-2 mb-12">
          {SLIDES.map((_, index) => (
            <div
              key={index}
              className={`h-2 rounded-full transition-all ${
                index === currentSlide
                  ? 'w-8 bg-telegram-button'
                  : 'w-2 bg-telegram-secondary'
              }`}
            />
          ))}
        </div>
      </div>

      {/* Next Button */}
      <div className="p-6">
        <button
          onClick={handleNext}
          className="w-full bg-telegram-button text-telegram-button-text rounded-xl py-4 font-semibold flex items-center justify-center gap-2"
        >
          {isLastSlide ? 'Get Started' : 'Next'}
          <ChevronRight size={20} />
        </button>
      </div>
    </div>
  );
}

export default OnboardingPage;
